import '../src/public-path';

import 'core-js/stable';
import 'regenerator-runtime/runtime';

import ReactDOM from 'react-dom';
import AppWrap from '../src/AppWrap';
import ReactGA from '../src/helpers/analytics';

if (typeof process === 'undefined') {
  window.process = {};
}
/* eslint-disable no-console */
// set a global replacement for console
window.Console = {
  log: process?.env?.NODE_ENV === 'development' || window?.location?.href?.includes?.('VERBOSE_CONSOLE')
    ? (...args) => { console.log(...args); }
    : () => {},
  assert: (...args) => {
    console.assert(...args);
  },
  warn: (...args) => {
    console.warn(...args);
  },
  error: (...args) => {
    console.error(...args);
  },
};

// Record a pageview on load
ReactGA.pageview(window.location.pathname + window.location.search);

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <AppWrap />,
    document.getElementById('root'),
  );
});
